// src/utils/moduleRegistry.js
import HeaderModule from "../BuilderModules/HeaderModule";
import ParagraphModule from "../BuilderModules/ParagraphModule";
import SubheaderModule from "../BuilderModules/SubheaderModule";
import BannerModule from "../BuilderModules/BannerModule";
import EmailModule from "../BuilderModules/EmailModule";
import UserDetailsModule from "../BuilderModules/UserDetailsModule";
import EmailDropdownModule from "../BuilderModules/EmailDropdownModule";
import ShortAnswerModule from "../BuilderModules/ShortAnswerModule";
import DoubleShortAnswerModule from "../BuilderModules/DoubleShortAnswerModule";
import LongAnswerModule from "../BuilderModules/LongAnswerModule";
import DateTimeModule from "../BuilderModules/DateTimeModule";
import DateRangeModule from "../BuilderModules/DateRangeModule";
import TimeRangeModule from "../BuilderModules/TimeRangeModule";
import CheckboxModule from "../BuilderModules/CheckboxModule";
import CheckboxGroupModule from "../BuilderModules/CheckboxGroupModule";
import CustomCheckboxGroupModule from "../BuilderModules/CustomCheckboxGroupModule";
import DynamicQuestionGroupModule from "../BuilderModules/DynamicQuestionGroupModule";
import DropdownSelectModule from "../BuilderModules/DropdownSelectModule";
import RadioButtonGroupModule from "../BuilderModules/RadioButtonGroupModule";
import TableModule from "../BuilderModules/TableModule";
import ImageModule from "../BuilderModules/ImageModule";
import ImageUploadModule from "../BuilderModules/ImageUploadModule";
import DocumentCheckerModule from "../BuilderModules/DocumentCheckerModule";
import SiteInformationModule from "../BuilderModules/SiteInformationModule";
import SignatureModule from "../BuilderModules/SignatureModule";
import HazardRegisterModule from "../BuilderModules/HazardRegisterModule";
import UserMultiSelectModule from "../BuilderModules/UserMultiSelectModule"; // <-- New import

export const moduleRegistry = {
  header: HeaderModule,
  paragraph: ParagraphModule,
  subheader: SubheaderModule,
  banner: BannerModule,
  email: EmailModule,
  user_details: UserDetailsModule,
  short_answer: ShortAnswerModule,
  double_short_answer: DoubleShortAnswerModule,
  long_answer: LongAnswerModule,
  datetime: DateTimeModule,
  date_range: DateRangeModule,
  time_range: TimeRangeModule,
  checkbox: CheckboxModule,
  checkbox_group: CheckboxGroupModule,
  custom_checkbox_group: CustomCheckboxGroupModule,
  dynamic_question_group: DynamicQuestionGroupModule,
  dropdown_select: DropdownSelectModule,
  radio_button_group: RadioButtonGroupModule,
  table: TableModule,
  image: ImageModule,
  image_upload: ImageUploadModule,
  document_checker: DocumentCheckerModule,
  site_information_viewer: SiteInformationModule,
  signature: SignatureModule,
  hazard_register: HazardRegisterModule,
  user_multi_select: UserMultiSelectModule,
  email_dropdown: EmailDropdownModule,
  // Add additional mappings as needed...
};
